export const LOCAL_ACCOUNT = "LOCAL_ACCOUNT";
